import OfficialApp from './OfficialApp.vue'
import MeApp from './MeApp.vue'
import './official-promotion.scss'
import './account.scss'
import { captureLoginError } from './account'
import { createApp } from 'vue'

/**
 * 轻量 history 路由：本站只有两张页面，不引入路由库。
 *
 *   · `/me`（含 `/me/`）→「我的应用」页（官网单点登录，设计文档 §5.3）；
 *   · 其余路径 → 原官网 / 邀请页，行为与改动前完全一致（含 `/promotion/?code=` 等历史入口）。
 *
 * 两张页面共用同一个 index.html 与同一份 /sdk/honeypot-launch.js，所以直接刷新 /me 只需要
 * 静态服务器把「找不到的路径」回退到 /index.html —— 现有 nginx（.tianshu/run.sh）的
 * `try_files $uri $uri/ /index.html` 与 vite preview 都已经这样做了。
 * 页面之间用普通链接整页跳转，不做前端内跳转：登录 / 退出本来就是整页跳转，没有必要维护路由状态。
 */
function isMyAppsPath(pathname: string): boolean {
  return /^\/me\/?$/.test(pathname)
}

// 登录回调失败码（/?login_error=）必须在 OfficialApp 清理地址栏参数之前读走。
captureLoginError()
document.documentElement.dataset.promotionSite = 'official'

createApp(isMyAppsPath(window.location.pathname) ? MeApp : OfficialApp).mount('#app')
